import { Component, Input } from '@angular/core';
import { OverviewApiKeysSummary } from '../../models/overview.model';

@Component({
  selector: 'app-api-keys-summary-card',
  standalone: false,
  templateUrl: './api-keys-summary-card.html',
})
export class ApiKeysSummaryCard {
  @Input({ required: true }) summary!: OverviewApiKeysSummary;

  /** "2 min ago" / "3 hours ago" / "5 days ago" no relative-time pipe in
   *  this app yet, and pulling one in for a single label here isn't worth it. */
  timeAgo(iso: string): string {
    const seconds = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
    if (seconds < 60) return 'just now';
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes} min${minutes === 1 ? '' : 's'} ago`;
    const hours = Math.round(minutes / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    const days = Math.round(hours / 24);
    return `${days} day${days === 1 ? '' : 's'} ago`;
  }
}
